import React from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

export interface Props {
  title: string;
  completedAll: boolean;
  complete?: boolean;
  current?: boolean;
  last?: boolean;
}

export const FlowProgressSection = ({
  title,
  completedAll,
  complete,
  current,
  last,
}: Props): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          mr: 2,
        }}
      >
        <Box
          className="FlowProgressSectionCircle"
          sx={{
            border: "solid 2px",
            borderRadius: 20,
            borderColor: complete || current ? "secondary.light" : "grey.100",
            width: 32,
            height: 32,
            p: "2px",
            backgroundColor:
              complete || current ? "success.light" : "common.white",
          }}
        >
          {(complete || completedAll) && <CheckIcon color="secondary" />}
        </Box>
        {!last && (
          <Box
            sx={{
              width: 2,
              height: 15,
              ml: 2,
              backgroundColor: complete ? "secondary.light" : "grey.100",
            }}
          />
        )}
      </Box>
      <Typography
        variant="body2"
        sx={{
          pt: "4px",
          fontWeight: current ? "bold" : "normal",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};
